import BaseServiceRetryWrapper from './baseRetry';
import { FINANCIAL_STATEMENT } from '../common/endpoints';

class FinancialStatementService extends BaseServiceRetryWrapper {
  retrieve = (id: string) => this.get(FINANCIAL_STATEMENT.retrieve(id));

  update = (id: string, data: unknown) => this.put(FINANCIAL_STATEMENT.update(id), data);

  destroy = (id: string) => this.delete(FINANCIAL_STATEMENT.destroy(id));

  create = (data: unknown) => this.post(FINANCIAL_STATEMENT.create(), data);

  list = () => this.get(FINANCIAL_STATEMENT.list());

  listByMeasurementPeriod = (measurementPeriodId: string) =>
    this.get(FINANCIAL_STATEMENT.listByMeasurementPeriod(measurementPeriodId));

  getByMeasurementDateId = (measurementPeriodId: string) =>
    this.get(FINANCIAL_STATEMENT.getByMeasurementDateId(measurementPeriodId));

  financialLtmNtm = (measurementPeriodId: string, versionId?: string) =>
    this.get(FINANCIAL_STATEMENT.financialLtmNtm(measurementPeriodId, versionId));

  getFinancialPeriodsFiscalYear = (companyMeasurementDateId: number | string, versionId?: number | string) =>
    this.get(FINANCIAL_STATEMENT.getFinancialPeriodsFiscalYear(companyMeasurementDateId, versionId));

  getFinancialsBasicDataListByMD = (measurementDateId: string) =>
    this.get(FINANCIAL_STATEMENT.getFinancialsBasicDataListByMD(measurementDateId));
}

export default FinancialStatementService;
